import React, { useState } from "react";
import { APP_PLATFORM_LOGO_MAP } from "../../../shared/constants";

interface AppLogoProps {
  logoUrl: string | null;
  platform: string;
  appName: string;
  className?: string;
}

const AppLogo: React.FC<AppLogoProps> = ({
  logoUrl,
  platform = "",
  appName,
  className,
}) => {
  const platformLogo = APP_PLATFORM_LOGO_MAP[platform?.toLowerCase() || ""];
  const [src, setSrc] = useState(logoUrl || platformLogo);

  return (
    <img
      src={src}
      alt={appName}
      className={`w-full h-full object-cover rounded-md ${className} ${
        src === platformLogo ? "border border-gray-200 p-1" : ""
      }`}
      onError={() => {
        if (src !== platformLogo) {
          setSrc(platformLogo);
        }
      }}
    />
  );
};

export default AppLogo;
